// extracted by mini-css-extract-plugin
module.exports = {"newsletter-section":"NewsletterContainer_newsletter-section__KvQGK","wrapper":"NewsletterContainer_wrapper__2oEw_","social-media-box":"NewsletterContainer_social-media-box__14LKg"};